<template>    
    <v-dialog
        v-model="dialog"
        width="500"
    >      
        <v-row>
            <v-col
            v-for="n in images.length"
            :key="n"
            class="d-flex child-flex"
            cols="12"
            >
                <v-img
                    :src="ImagesBaseUrl + images[n-1].Ruta"
                    aspect-ratio="1"
                    class="grey lighten-2"
                >
                    <template v-slot:placeholder>
                    <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                    >
                        <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                        ></v-progress-circular>
                    </v-row>
                    </template>
                </v-img>
            </v-col>
        </v-row>
    </v-dialog>  
</template>
<script>

export default {
    name: 'dialogDocumentImages',
    components:{
      
    },
    data () {
      return {                     
      }
    },    
    computed:{
        dialog: {
            get(){
                return this.$store.state.dialogDocumentImages;
            },
            set(value){
                this.$store.state.dialogDocumentImages = value;
            }
        },
        images: {
            get(){
                console.log(this.$store.state.storedImages);
                return this.$store.state.storedImages;
            }
        }
    }
}
</script>